import { useState } from 'react';
import TicketTypesTab from './TicketTypesTab';

const TABS = [
  { key: "tickets", label: "Tickets" },
  { key: "tables", label: "Tables" },
];

const TicketsTablePage = ({eventId}) => {
  const [activeTab, setActiveTab] = useState("tickets");


  return (
    <div className="space-y-4">
      {/* TABS */}
      <div className="flex justify-evenly items-center border-b border-white/10">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`pb-3 pl-20 pr-20 text-sm font-medium transition
              ${
                activeTab === tab.key
                  ? "text-pink-500 border-b-2 border-pink-500"
                  : "text-slate-400 hover:text-white"
              }
            `}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* CONTENT */}
      <div className="bg-slate-900/60 border border-white/10 rounded-xl p-5">
        {activeTab === "tickets" && (
          <div>
            <TicketTypesTab eventId={eventId} />
          </div>
        )}

        {activeTab === "tables" && (
          <div>
            Coming Soon
          </div>
        )}
      </div>
    </div>
  );
};

export default TicketsTablePage;